"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShelveMainProcess = void 0;
const ltpoint_1 = require("../../cadplugins/cad/ltpoint");
const ltfeature_1 = require("../../cadplugins/data/ltfeature");
const shelveIdentify_1 = require("./shelveIdentify");
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const ltentity_1 = require("../../cadplugins/cad/ltentity");
const column_1 = require("./column");
const shelveSprinklerGenerator_1 = require("./shelveSprinklerGenerator");
const sprinklerutils_1 = require("../sprinkler/sprinklerutils");
const riserGroup_1 = require("./riserGroup");
const pipeNode_1 = require("../pipe/pipeNode");
const ltfields_1 = require("../../cadplugins/data/ltfields");
const shelveDrawUtil_1 = require("./shelveDrawUtil");
const pipeSizeMap_1 = require("../sizeCompute/pipeSizeMap");
const pipeSizeTextDrawer_1 = require("../pipe/pipeSizeTextDrawer");
const boundingBox_1 = require("../boundingBox");
class ShelveMainProcess {
    constructor(cadMap, sprinklerName, relationshipArray, drawscale) {
        this._identify = new shelveIdentify_1.ShelveIdentify();
        this._resultMaps = new Array();
        this._cadMap = cadMap;
        let mainPipeLayer;
        let childPipeLayer;
        let riserLayer;
        let pipeDiameterTextLayer;
        let pipeDozzleLayer;
        for (let layer of cadMap.getLayers()) {
            if (!mainPipeLayer && layer.name == sprinklerutils_1.MAINPIPE_LAYER) {
                mainPipeLayer = layer;
            }
            else if (!childPipeLayer && layer.name == sprinklerutils_1.BRANCHPIPE_LAYER) {
                childPipeLayer = layer;
            }
            else if (!riserLayer && layer.name == sprinklerutils_1.STANDPIPE_LAYER) {
                riserLayer = layer;
            }
            else if (!pipeDiameterTextLayer && layer.name == sprinklerutils_1.PIPDIAMETER_ANNO_LAYER) {
                pipeDiameterTextLayer = layer;
            }
            else if (!pipeDozzleLayer && layer.name == sprinklerutils_1.SPRINKLER_NOZZLE_LAYER) {
                pipeDozzleLayer = layer;
            }
        }
        this._mainPipeLayer = mainPipeLayer;
        this._childPipeLayer = childPipeLayer;
        this._riserLayer = riserLayer;
        this._pipeDozzleLayer = pipeDozzleLayer;
        this._pipeDiameterTextLayer = pipeDiameterTextLayer;
        this._pipeSizeMap = new pipeSizeMap_1.PipeSizeMap(relationshipArray);
        this._sprinklerName = sprinklerName;
        this._drawscale = drawscale;
    }
    extractShelveUnit(selectFeatures, clipPolygonLTPoints) {
        let clipPolygonPoints = new Array();
        for (let point of clipPolygonLTPoints) {
            clipPolygonPoints.push(new Coordinate_js_1.default(point.x, point.y));
        }
        let segments = this.getSegmentsFromLineFeatures(selectFeatures);
        this._shelveTemplate = this._identify.extractTemplate(clipPolygonPoints, segments);
    }
    generateSprinkler(selectFeatures, isOddLevel) {
        let segments = this.getSegmentsFromLineFeatures(selectFeatures); //提取得到的线段
        let columns = this.getColumnsFromHatchFeatures(selectFeatures); //提取得到的柱子
        let shelves = this._identify.matchByTemplate(this._shelveTemplate, segments);
        let shelveRows = this._identify.divideIntoRows(shelves);
        let shelveRowGroups = this._identify.groupingRows(shelveRows);
        let shelveSprinklerGenerator = new shelveSprinklerGenerator_1.ShelveSprinklerGenerator(this._cadMap, this._childPipeLayer, this._pipeDozzleLayer, this._riserLayer, this._pipeDiameterTextLayer, columns, this._sprinklerName, this._pipeSizeMap);
        //将生成结果存储起来，供计算主管线时使用
        let resultMap = shelveSprinklerGenerator.generate(shelveRowGroups, isOddLevel, false, this._drawscale);
        this._resultMaps.push(resultMap);
    }
    generateMainPipe(selectFeatures, mainPipePoints) {
        //这一部分按奇数层货架进行计算
        let segments = this.getSegmentsFromLineFeatures(selectFeatures); //提取得到的线段
        let columns = this.getColumnsFromHatchFeatures(selectFeatures); //提取得到的柱子
        let shelves = this._identify.matchByTemplate(this._shelveTemplate, segments);
        let shelveRows = this._identify.divideIntoRows(shelves);
        let shelveRowGroups = this._identify.groupingRows(shelveRows);
        let shelveSprinklerGenerator = new shelveSprinklerGenerator_1.ShelveSprinklerGenerator(this._cadMap, this._childPipeLayer, this._pipeDozzleLayer, this._riserLayer, this._pipeDiameterTextLayer, columns, this._sprinklerName, this._pipeSizeMap);
        //-->进入主管道计算步骤
        //先计算一下主管道步骤的立管位置
        let resultMap_main = shelveSprinklerGenerator.generate(shelveRowGroups, true, true, this._drawscale);
        //#region 判断方向
        //通过多段线的包围盒来判断多段线的方向是横向还是纵向
        let mainPipesBoundingBox = new boundingBox_1.BoundingBox(mainPipePoints);
        let isHorizontal = mainPipesBoundingBox.getLengthX() > mainPipesBoundingBox.getLengthY();
        //通过立管来计算数据的包围盒
        let boundingBox = new boundingBox_1.BoundingBox();
        for (let sprinklerGroups of resultMap_main.values()) {
            for (let sprinklerGroup of sprinklerGroups) {
                boundingBox.expand(sprinklerGroup._riserPoint);
            }
        }
        let center = boundingBox.getCenter();
        let reverseInRow;
        let reverseBetweenRows;
        if (isHorizontal) { //横向。分四种情况。主管线绘制在货架上边or绘制在货架下边。主管线从左到右绘制or从右到左绘制。2x2=4种情况
            if (mainPipePoints[0].y > center.y) { //主管线在货架上边
                reverseBetweenRows = false;
            }
            else { //主管线在货架下边
                reverseBetweenRows = true;
            }
            if (mainPipePoints[0].x < mainPipePoints[1].x) { //从左到右绘制
                reverseInRow = true;
            }
            else { //从右到左绘制
                reverseInRow = false;
            }
        }
        else { //纵向。分四种情况。主管线绘制在货架左边or绘制在货架右边。主管线从上到下绘制or从下到上绘制。2x2=4种情况
            if (mainPipePoints[0].x < center.x) { //主管线在货架左边
                reverseInRow = true;
            }
            else { //主管线在货架右边
                reverseInRow = false;
            }
            if (mainPipePoints[0].y > mainPipePoints[1].y) { //从上到下绘制
                reverseBetweenRows = false;
            }
            else { //从下到上绘制
                reverseBetweenRows = true;
            }
        }
        //#endregion
        //上述8种情况反馈到同一行货架的方向和货架行的连接方向上，共有4种情况（同一行货架：左->右，右->左，2种），（货架行：上->下，下->2种）
        //计算每一行的管点数量，按800个喷头为单位进行分组
        let sprinklerCount_rows = new Array();
        let accumulateCount = 0; //累计的喷头数
        let riserGroups = [new riserGroup_1.RiserGroup()];
        //计算时默认是从上到下，如果需要从下到上，则需要翻转数组
        let resultRows = reverseBetweenRows ? Array.from(resultMap_main).reverse() : Array.from(resultMap_main);
        for (let [shelveRowGroup, sprinklerGroups] of resultRows) {
            let sprinklerCount_row = 0;
            for (let sprinklerGroup of sprinklerGroups) {
                //计算该立管连接的喷头数量
                let totalSprinklerCount = this.computeRiserTotalSprinklerCount(sprinklerGroup._riserName, this._resultMaps);
                sprinklerCount_row += totalSprinklerCount;
                sprinklerGroup._riserNode._count = totalSprinklerCount;
            }
            sprinklerCount_rows.push(sprinklerCount_row);
            //累计
            accumulateCount += sprinklerCount_row;
            if (accumulateCount > 800) { //800个喷头一组
                riserGroups.push(new riserGroup_1.RiserGroup());
                accumulateCount = 0;
            }
            riserGroups[riserGroups.length - 1].addRow(shelveRowGroup);
            riserGroups[riserGroups.length - 1].addRiserPoints(sprinklerGroups);
        }
        //用于绘制时获取立管的名称，以及构造立管节点时赋予喷头数量
        let totalSprinklerGroups = new Array();
        for (let sprinklerGroups of resultMap_main.values()) {
            totalSprinklerGroups = totalSprinklerGroups.concat(sprinklerGroups);
        }
        //主管线数组
        let rootNodes = new Array();
        //取绘制的主管线的第一个点作为起始点
        let standardPoint = new Coordinate_js_1.default(mainPipePoints[0].x, mainPipePoints[0].y);
        for (let i = 0; i < riserGroups.length; i++) {
            let riserGroup = riserGroups[i];
            //将立管分行
            let rows_map = new Map();
            for (let riserPoint of riserGroup._riserPoints) {
                let pointArr = rows_map.get(riserPoint.y);
                if (pointArr) {
                    pointArr.push(riserPoint);
                }
                else {
                    rows_map.set(riserPoint.y, [riserPoint]);
                }
            }
            //排序（上到下，右到左）
            let rows = Array.from(rows_map);
            //需要根据reverseBetweenRows的值来判断排序顺序
            if (reverseBetweenRows) {
                rows.sort(function (a, b) { return a[0] - b[0]; });
            }
            else {
                rows.sort(function (a, b) { return b[0] - a[0]; });
            }
            for (let row of rows) {
                //需要根据reverseInRow的值来判断排序顺序
                if (reverseInRow) {
                    row[1].sort(function (a, b) { return a.x - b.x; });
                }
                else {
                    row[1].sort(function (a, b) { return b.x - a.x; });
                }
            }
            //按货架的最大X值，偏移600
            let convergencePoint_x;
            if (reverseInRow) { //连接点放左边
                convergencePoint_x = riserGroup._rows[0]._shelveRows[0].getBoundingBox().min.x - 600;
            }
            else { //连接点放右边
                convergencePoint_x = riserGroup._rows[0]._shelveRows[0].getBoundingBox().max.x + 600;
            }
            //区分横向和纵向两种情况
            if (!isHorizontal) { //主管线是纵向的
                //取中间行的Y值作为连接点的Y值
                //选中间那一行的点作为连接点
                let middleIndex = Math.floor(rows.length / 2);
                let convergenceNode = this.computeRowRootNode(convergencePoint_x, rows[middleIndex], totalSprinklerGroups);
                //从中间往上遍历
                let lastNode = convergenceNode;
                for (let j = middleIndex - 1; j >= 0; j--) {
                    let node = this.computeRowRootNode(convergencePoint_x, rows[j], totalSprinklerGroups);
                    lastNode.addChildNode(node);
                    lastNode = node;
                }
                //从中间往下遍历
                lastNode = convergenceNode;
                for (let j = middleIndex + 1; j < rows.length; j++) {
                    let node = this.computeRowRootNode(convergencePoint_x, rows[j], totalSprinklerGroups);
                    lastNode.addChildNode(node);
                    lastNode = node;
                }
                //连接到起始点
                let rootNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(standardPoint.x, standardPoint.y), pipeNode_1.PipeNodeType.Main);
                rootNodes.push(rootNode);
                let linkNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(standardPoint.x, convergenceNode._point.y), pipeNode_1.PipeNodeType.Main);
                rootNode.addChildNode(linkNode);
                linkNode.addChildNode(convergenceNode);
                //连接完一组点，下一组点要向外偏移
                if (reverseInRow) {
                    standardPoint.x -= 600;
                }
                else {
                    standardPoint.x += 600;
                }
            }
            else { //主管线是横向的
                let convergenceNode = this.computeRowRootNode(convergencePoint_x, rows[0], totalSprinklerGroups);
                let lastNode = convergenceNode;
                for (let j = 1; j < rows.length; j++) {
                    let node = this.computeRowRootNode(convergencePoint_x, rows[j], totalSprinklerGroups);
                    lastNode.addChildNode(node);
                    lastNode = node;
                }
                if (reverseInRow) {
                    convergenceNode._point.x -= i * 600;
                }
                else {
                    convergenceNode._point.x += i * 600;
                }
                //连接到起始点
                let rootNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(standardPoint.x, standardPoint.y), pipeNode_1.PipeNodeType.Main);
                rootNodes.push(rootNode);
                let linkNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(convergenceNode._point.x, standardPoint.y), pipeNode_1.PipeNodeType.Main);
                rootNode.addChildNode(linkNode);
                linkNode.addChildNode(convergenceNode);
                //连接完一组点，下一组点要向外偏移
                if (reverseBetweenRows) {
                    standardPoint.y += 600;
                }
                else {
                    standardPoint.y -= 600;
                }
            }
        }
        this.drawMainPipe(rootNodes, totalSprinklerGroups);
    }
    //从线段要素和多段线要素中获取线段
    getSegmentsFromLineFeatures(features) {
        let segments = new Array();
        for (let feature of features) {
            let geometry = feature.getGeometry();
            //仅处理线段、多段线和块
            if (geometry instanceof ltentity_1.LTLine) {
                segments.push(new LineSegment_js_1.default(geometry.getStart().x, geometry.getStart().y, geometry.getEnd().x, geometry.getEnd().y));
            }
            else if (geometry instanceof ltentity_1.LTPolyline) {
                let points = geometry.subData().getEndPoints();
                for (let i = 0; i < points.length - 1; i++) {
                    segments.push(new LineSegment_js_1.default(points[i].x, points[i].y, points[i + 1].x, points[i + 1].y));
                }
            }
            else if (geometry instanceof ltentity_1.LTEntityPoint) {
                for (let data of geometry._graphicsData) {
                    let pointValues = data.points;
                    let points = new Array();
                    for (let i = 0; i < pointValues.length - 1; i += 2) {
                        points.push(new ltpoint_1.LTPoint(pointValues[i], pointValues[i + 1]));
                    }
                    for (let i = 0; i < points.length - 1; i++) {
                        segments.push(new LineSegment_js_1.default(points[i].x, points[i].y, points[i + 1].x, points[i + 1].y));
                    }
                }
            }
            else {
                continue;
            }
        }
        return segments;
    }
    getColumnsFromHatchFeatures(features) {
        let columns = new Array(); //提取得到的柱子
        for (let feature of features) {
            let geometry = feature.getGeometry();
            if (geometry instanceof ltentity_1.LTHatch) { //这里是提取柱子，目的是为了判断是否拆分并排双行货架。目前仅考虑这种LTHacth类型
                let hatch = geometry;
                let points = hatch.subData().getEndPoints();
                let columnSegments = new Array();
                for (let i = 0; i < points.length - 1; i++) {
                    let p0 = new Coordinate_js_1.default(points[i].x, points[i].y);
                    let p1 = new Coordinate_js_1.default(points[i + 1].x, points[i + 1].y);
                    columnSegments.push(new LineSegment_js_1.default(p0, p1));
                }
                columns.push(new column_1.Column(columnSegments));
            }
        }
        return columns;
    }
    computeRowRootNode(convergencePoint_x, row, totalSprinklerGroups) {
        let row_root_node = new pipeNode_1.PipeNode(new Coordinate_js_1.default(convergencePoint_x, row[0]), pipeNode_1.PipeNodeType.Main);
        let lastNode = row_root_node;
        for (let riserPoint of row[1]) {
            let node = new pipeNode_1.PipeNode(new Coordinate_js_1.default(riserPoint), pipeNode_1.PipeNodeType.Child);
            lastNode.addChildNode(node);
            lastNode = node;
            //赋予喷头数量
            let sprinklerGroup = this.getSprinklerGroup(riserPoint, totalSprinklerGroups);
            node._count = sprinklerGroup._riserNode._count;
        }
        return row_root_node;
    }
    //计算立管所带的喷头总数
    computeRiserTotalSprinklerCount(riserName, resultMaps) {
        let count = 0;
        for (let map of resultMaps) {
            for (let sprinklerGroups of map.values()) {
                for (let sprinklerGroup of sprinklerGroups) {
                    if (riserName == sprinklerGroup._riserName) {
                        count += sprinklerGroup._riserNode.computeChildrenNodes();
                    }
                }
            }
        }
        return count;
    }
    //TODO：这下面的绘制代码需要整合一下
    drawMainPipe(rootNodes, totalSprinklerGroups) {
        let shelveDrawUtil = new shelveDrawUtil_1.ShelveDrawUtil(this._riserLayer, this._cadMap);
        for (let i = 0; i < rootNodes.length; i++) {
            this.traverseToDraw(rootNodes[i], totalSprinklerGroups, i, shelveDrawUtil);
        }
    }
    traverseToDraw(node, totalSprinklerGroups, groupIndex, shelveDrawUtil) {
        for (let child of node._children) {
            let line = new ltentity_1.LTLine(new ltpoint_1.LTPoint(node._point.x, node._point.y), new ltpoint_1.LTPoint(child._point.x, child._point.y));
            if (child._type == pipeNode_1.PipeNodeType.Child) { //Child类型为立管
                let sprinklerGroup = this.getSprinklerGroup(child._point, totalSprinklerGroups);
                shelveDrawUtil.addRiserBlockToLayer(new ltpoint_1.LTPoint(child._point.x, child._point.y), sprinklerGroup._riserName, groupIndex, child._count, this._drawscale);
            }
            //计算管径
            let riserCount = child.computeRiserCount();
            let text = this._pipeSizeMap.getPipeSizeStr(riserCount);
            let ltText = pipeSizeTextDrawer_1.PipeSizeTextDrawer.getLTText(line.getStart(), line.getEnd(), text, this._drawscale);
            //构建管径文字要素
            let textFeature = new ltfeature_1.LTFeature({
                geometry: ltText,
                layer: this._pipeDiameterTextLayer,
                xdata: JSON.stringify({
                    source: "autoGenerate",
                }),
            });
            textFeature.setValue(ltfields_1.FieldNames.EntityLayer, textFeature.layer.name);
            textFeature.setValue(ltfields_1.FieldNames.EntityType, "AcDbText");
            textFeature.setValue(ltfields_1.FieldNames.Linetype, ltentity_1.dwg_bylayer);
            this._cadMap.addFeature(textFeature);
            let lineFeature = new ltfeature_1.LTFeature({
                geometry: line,
                layer: this._mainPipeLayer,
                xdata: JSON.stringify({
                    pipeSize: text,
                    source: "autoGenerate",
                }),
            });
            lineFeature.setValue(ltfields_1.FieldNames.EntityLayer, lineFeature.layer.name);
            lineFeature.setValue(ltfields_1.FieldNames.Color, ltentity_1.dwg_bylayer);
            lineFeature.setValue(ltfields_1.FieldNames.Linetype, ltentity_1.dwg_bylayer);
            lineFeature.setValue(ltfields_1.FieldNames.Width, 0.0);
            lineFeature.setValue(ltfields_1.FieldNames.Rotate, 0.0);
            this._cadMap.addFeature(lineFeature);
            this.traverseToDraw(child, totalSprinklerGroups, groupIndex, shelveDrawUtil);
        }
    }
    getSprinklerGroup(point, totalSprinklerGroups) {
        for (let sprinklerGroup of totalSprinklerGroups) {
            if (point.equals2D(sprinklerGroup._riserPoint)) {
                return sprinklerGroup;
            }
        }
        //debugger
        throw Error("没找到立管");
    }
}
exports.ShelveMainProcess = ShelveMainProcess;
